export const USE_WIDTH_RESIZE_MAX_WIDTH = Infinity

export const USE_WIDTH_RESIZE_MIN_WIDTH = 0

export const USE_WIDTH_RESIZE_INITIAL_STATE = {
  pointerId: null,
  startWidth: 0,
  startX: 0,
}
